import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './i18n';
import '../public/assets/css/styles.css';

const app = createApp(App);
app.use(router);
app.use(i18n);

// Set initial locale from localStorage
if (typeof window !== 'undefined' && window.localStorage) {
    const storedLang = localStorage.getItem('language');
    if (storedLang && ['en', 'nl', 'es'].includes(storedLang)) {
        // In legacy mode, locale is a string, not a ref
        i18n.global.locale = storedLang;
    }
}

app.mount('#app');
